export default async function sleep(ms: number) {
  await (async (ms: number) => new Promise(resolve => setTimeout(resolve, ms)))(ms);
}
